import changeCart from '../../lib/changeCart';
import addToCart from '../../lib/addToCart';
import { initSwiper } from '../../components/swiper';
import { SELECTORS } from '../../utils/constants';

async function refreshCartForm(formEl) {
  const response = await fetch(window.location.href, {
    method: 'GET',
    cache: 'no-store',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to refresh cart form: ${response.status}`);
  }

  const html = await response.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const nextForm = doc.querySelector('form[action*="/cart"]');

  if (!nextForm || !formEl) {
    throw new Error('Could not find cart form in refreshed markup');
  }

  formEl.innerHTML = nextForm.innerHTML;
  const upsellSlider = formEl.querySelector('[data-swiper]');
  if (upsellSlider) {
    initSwiper(upsellSlider);
  }
}

const CLASS_OPACITY_50 = 'opacity-50';

function initCartPage() {
  let upsellLoading = false;

  document.addEventListener('change', async (event) => {
    const input = event.target.closest('[data-cart-qty]');
    if (!input) return;

    const lineItemKey = input.dataset.cartQty;
    const newQty = +input.value;
    const line = input.closest('[data-cart-line-item]');
    const formEl = input.closest('form');

    if (line) {
      line.classList.add(CLASS_OPACITY_50);
    }
    input.disabled = true;

    try {
      await changeCart(lineItemKey, newQty);
      await refreshCartForm(formEl);
    } catch (error) {
      console.error('Failed to update cart:', error);
      window.location.reload();
    }
  });

  document.addEventListener('click', async (event) => {
    const atcBtn = event.target.closest('[data-cart-upsell-atc]');
    if (!atcBtn || upsellLoading) return;

    // Minicart upsell has its own handler via renderMinicart
    if (event.target.closest('[data-minicart]')) return;

    const loadingSpinner = atcBtn.querySelector(SELECTORS.LOADING_SPINNER);
    upsellLoading = true;
    loadingSpinner?.classList.remove('hidden');
    atcBtn.classList.add(CLASS_OPACITY_50);
    atcBtn.disabled = true;

    try {
      await addToCart(atcBtn.dataset.cartUpsellAtc, 1);
      window.location.reload();
    } catch (error) {
      console.error('Failed to add upsell to cart:', error);
    } finally {
      upsellLoading = false;
      loadingSpinner?.classList.add('hidden');
      atcBtn.classList.remove(CLASS_OPACITY_50);
      atcBtn.disabled = false;
    }
  });
}

export default initCartPage;
